/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 07.09.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Classnames from 'classnames';

import moment from 'moment';
import _get from 'lodash/get';
import _reverse from 'lodash/reverse';
import _isEqual from 'lodash/isEqual';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _difference from 'lodash/difference';

import Translate from '../../components/Translate';

import {Guid} from '../../utils';

import {ShowToast, HideToast} from '../../actions/common/actions-common';


//this.props.ShowToast({
//  type: 'favorite',
//  message: 'Suicide Squad',
//  operation: 'favorite_add_success',
//  isBlocked: true,
//  isPulse: true,
//  isError: true
//});

class Toasts extends Component {
  constructor(props) {
    super(props);

    this.toastHideTimeouts = {};

    this.state = {
      toasts: []
    };
  }

  componentDidMount() {

    this.setState({
        toasts: _reverse(this.props.toasts.map((toast) => {
          if (!toast.id) toast.id = Guid();
          if (toast.isBlocked) toast._time = moment.unix(toast.timestamp);

          if (!toast.isBlocked) this.toastHideTimeouts[toast.id] = setTimeout(()=> {

            this.props.HideToast(toast.id);
          }, toast.timeout || 1000 * 15);

          return toast;
        }))
      }
    );
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(this.props.toasts, newProps.toasts)) {

      let toasts = newProps.toasts.map((toast) => {
        if (!toast.id) toast.id = Guid();
        if (toast.isBlocked) toast._time = moment.unix(toast.timestamp);

        return toast;
      });

      let oldTimeouts = _keys(this.toastHideTimeouts);
      let newTimeouts = _map(toasts, 'id');
      let diff = _difference(oldTimeouts, newTimeouts);

      diff.forEach((timeout) => {

        clearTimeout(this.toastHideTimeouts[timeout]);
      });

      toasts.forEach((toast) => {

        if (!this.toastHideTimeouts[toast.id] && !toast.isBlocked) this.toastHideTimeouts[toast.id] = setTimeout(()=> {

          this.props.HideToast(toast.id);
        }, toast.timeout || 1000 * 15);
      });

      this.setState({
          toasts: _reverse(toasts)
        }
      );
    }
  }

  _renderIcon(type) {

    switch (type) {
      case 'record':
        return (<i className="ic ic-rdvr ic-24px"></i>);

      case 'favorite':
        return (<i className="ic ic-fav-in-fill ic-24px"></i>);

      case 'service':
        return (<i className="ic ic-antenna ic-24px"></i>);

      case 'cookies':
        return (<i className="ic ic-cookies ic-24px"></i>);

      case 'adblock':
        return (<i className="ic ic-forbidden ic-24px"></i>);

      default:
        return (<i className="ic ic-info-circle ic-24px"></i>);
    }
  }

  _renderToasts() {

    return this.state.toasts.map((toast) => {
      let toastClasses = Classnames({
        'toast': true,
        'pulse': toast.isPulse,
        'toast-error': toast.isError
      });

      return (
        <div key={'toast_' + toast.id} className="toast-container" onClick={this.props.HideToast.bind(this, toast.id)}>
          <div className={toastClasses}>
            <div className="info-container">
              <strong className="info-type color-grey"> {toast.isBlocked && toast._time.format(_get(Config, 'toast.toast_time_format', 'HH:mm')) } <Translate content={'toast.type.' + toast.type} /> </strong>
              <div className="info-message" style={{textTransform: 'capitalize'}}> {toast.message}&nbsp; </div>
              <div className="info-operation-progress">{toast.operation && <Translate content={'toast.operation.' + toast.operation} />}</div>
            </div>
            <div className="info-icon">{this._renderIcon(toast.type)}</div>
          </div>
        </div>
      );
    });
  }

  render() {

    return (<div className="toasts-container">
      <ReactCSSTransitionGroup
        transitionName="toast-animation"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        {this._renderToasts()}
      </ReactCSSTransitionGroup>
    </div>);
  }
}

const mapStateToProps = ({common: {toasts}}) => {

  return {
    toasts
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({ShowToast, HideToast}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Toasts);



// WEBPACK FOOTER //
// ./src/containers/Toasts/toasts.js